export class ConfirmationResponse {
    entityId: number;
    isConfirmed: boolean;
}